import React from "react";
import { Box, Tooltip } from "@mui/material";
import type { WebsiteStatus } from "../types/venues.types";

const STATUS: Record<Exclude<WebsiteStatus, null>, { label: string; color: string; hint: string }> = {
  live: { label: "On website", color: "#16a34a", hint: "Published and showing on the website" },
  hidden: { label: "Live · hidden", color: "#d97706", hint: "Published, but the website hides it until missing details are fixed" },
  draft: { label: "Draft", color: "#64748b", hint: "Being prepared; not on the website yet" },
};

/** A small pill saying where the venue stands on the public website. */
export const WebsiteStatusBadge: React.FC<{ status: Exclude<WebsiteStatus, null> }> = ({ status }) => {
  const { label, color, hint } = STATUS[status];
  return (
    <Tooltip title={hint}>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          px: 1,
          py: 0.25,
          borderRadius: 999,
          bgcolor: "rgba(255,255,255,0.95)",
          color: "#1f2937",
          boxShadow: "0 1px 3px rgba(0,0,0,.2)",
          fontSize: 11.5,
          fontWeight: 700,
        }}
      >
        <Box component="span" sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: color }} />
        {label}
      </Box>
    </Tooltip>
  );
};

export default WebsiteStatusBadge;
